import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react'; // ADDED

const J = {
    muted: '#a3d1ff',
    accent: '#66b2ff',
};

const publicNavItems = ['Features', 'Guide', 'FAQ', 'Blog'];

/**
 * Horizontal nav buttons for desktop AppBar.
 * Dashboard only visible when signed in.
 */
export default function AppBarNavItems() {
    const navigate = useNavigate();
    const { userId } = useAuth(); // ADDED

    // ADDED — combine public items with conditional Dashboard
    const navItems = userId ? [...publicNavItems, 'Dashboard'] : publicNavItems;

    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {navItems.map((item) => (
                <Button
                    key={item}
                    variant="text"
                    size="small"
                    onClick={() => navigate(`/${item.toLowerCase()}`)}
                    sx={{
                        color: J.muted,
                        '&:hover': { color: J.accent, bgcolor: 'transparent' },
                    }}
                >
                    {item}
                </Button>
            ))}
        </Box>
    );
}
